import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Bell } from 'lucide-react';
import { API } from '../../config';
import { requestNotificationPermission, getPushPlatform } from '../../services/pushService';

const post = (body) => axios.post(`${API}/auth/alerts-popup`, body).catch(() => null);

// Asked right after an import: enable push alerts for this selection.
// pushState 'prompt' → full consent (enables all push); 'granted' → light per-selection question.
export const NotifyAskModal = ({ open, pushState, onAnswer, title, text, yesLabel = 'Sì, avvisami', noLabel = 'No, grazie', zClass = 'z-[90]' }) => {
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const full = pushState !== 'granted';

  const yes = async () => {
    setBusy(true);
    let token = null;
    try { token = await requestNotificationPermission(); } catch { token = null; }
    if (token) await axios.post(`${API}/notifications/register-token`, { token, platform: getPushPlatform() }).catch(() => {});
    if (full) await post({ action: token ? 'system_granted' : 'system_denied', needs_email: false, needs_push: true });
    setBusy(false);
    if (!token) toast.error('Notifiche bloccate: attivale dalle impostazioni del telefono o del browser.');
    onAnswer(!!token);
  };

  return (
    <div className={`fixed inset-0 ${zClass} bg-black/80 backdrop-blur-sm flex items-end sm:items-center justify-center p-4`} data-testid="my-selection-notify-modal">
      <div className="bg-gradient-to-b from-[#1F1F1F] to-[#171717] border border-[#F5A623]/30 rounded-3xl w-full max-w-md p-6">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#F5A623] to-[#FF6B6B] flex items-center justify-center mx-auto mb-4">
          <Bell className="w-7 h-7 text-[#1A1A1A]" />
        </div>
        <h2 className="text-lg font-bold text-white text-center leading-snug mb-2" data-testid="my-selection-notify-title">
          {title || (full ? 'Vuoi che ti avvisiamo quando i tuoi eventi vanno a segno?' : 'Ti avvisiamo per questa selezione?')}
        </h2>
        <p className="text-sm text-gray-400 text-center mb-6">
          {text || (full
            ? 'Riceverai una notifica per ogni evento e il riepilogo finale. Attiveremo le notifiche dell’app: puoi disattivarle quando vuoi.'
            : 'Una notifica per ogni evento andato a segno o saltato, più il riepilogo finale.')}
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button onClick={() => onAnswer(false)} disabled={busy} className="h-12 rounded-2xl border border-white/15 text-gray-300 font-bold text-sm" data-testid="my-selection-notify-no">
            {noLabel}
          </button>
          <button onClick={yes} disabled={busy} className="h-12 rounded-2xl bg-[#F5A623] text-[#1A1A1A] font-black text-sm disabled:opacity-50" data-testid="my-selection-notify-yes">
            {yesLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotifyAskModal;
